import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMLoggerService } from '@services/lm-logger.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LMHomePageUtilService {

  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService)  {}

  public getHomePageRedirect(url: string):  Observable<any> {
    return this.http
      .get(url).pipe(
        catchError(error => {
          this.lmLoggerService.error(error);
          return throwError(error || 'Server error');
        }));
  }
}
